import { useEffect } from "react";
import { useRouteError } from "react-router";
import { useServices } from "../services/services-context";


export const RouteErrorBoundary = (): null => {
	const { error: errorService } = useServices();
	const error = useRouteError();
	useEffect(() => {
		if(error) {
			errorService.handleError("COMPONENT", error);
		}
	}, [ error, errorService ]);

	return null;
};